import { ICompetition } from '@pssa/types';

const nthNumber = (number: number) => {
  return number > 0
    ? ['th', 'st', 'nd', 'rd'][(number > 3 && number < 21) || number % 10 > 3 ? 0 : number % 10]
    : '';
};

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const monthYear = date.toLocaleDateString('en-GB', {
    month: 'short',
    year: 'numeric',
  });

  return `${day}${nthNumber(day)} ${monthYear}`;
};

export const competitionLabel = ({ date, distance }: ICompetition) =>
  `${formatDate(date)} (${distance} Yrds)`;
